import { v4 as uuidv4 } from "uuid";
import { getWidthOptions } from "@/react/components/shared/BuilderUI/utils/sizeStyleHelpers";
import {
  getColorOptions,
  getFontSizeOptions,
  getFontWeightOptions,
  getTextAlignOptions,
} from "@/react/components/shared/BuilderUI/utils/textStyleHelpers";
import type { BaseBlock } from "@circle-react-shared/BuilderUI/DataModel.types";
import { defaultData as NumberedCardDefaultData } from "@circle-react-shared/BuilderUI/DefaultBlocks/Sections/NumberedCardBlock/NumberedCardBlockDefaultData";
import {
  createH3Block,
  createH5Block,
  createPBlock,
} from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/textBlocksHelpers";

export const createNumberedCardBlock = ({
  number,
  title,
  description,
}: {
  number: string;
  title: string;
  description: string;
}): BaseBlock => ({
  ...NumberedCardDefaultData,
  id: uuidv4(),
  props: {
    ...NumberedCardDefaultData.props,
    number: {
      ...NumberedCardDefaultData.props.number,
      type: "children",
      prop: "children",
      value: [
        createH3Block({
          text: number,
          styles: {
            textAlign: getTextAlignOptions("center"),
            fontWeight: getFontWeightOptions("semibold"),
            color: getColorOptions(
              "var(--theme-website-primary-button-default-text-color)",
            ),
            fontSize: getFontSizeOptions("1.25rem"),
            width: getWidthOptions({
              defaultValue: "100%",
            }),
          },
        }),
      ],
    },
    content: {
      ...NumberedCardDefaultData.props.content,
      type: "children",
      prop: "children",
      value: [
        createH5Block({
          text: title,
        }),
        createPBlock({
          text: description,
          paragraphStyle: "p3",
        }),
      ],
    },
  },
});
